import React from 'react'
import {Flex, Text, Button, Image} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import {ArrowRightIcon} from '../../../../../icons'
import congratsImage from '../../../../../../../assets/images/congrats.svg'
import {useAcquisitionDecision} from '../../../../../hooks/useAcquisitionDecision'

const Supported = () => {
  const {t} = useTranslation('onboarding')

  const {transitionTo} = useAcquisitionDecision()

  return (
    <Flex minH="100%" align="center" justify="center">
      <Flex flexDirection="column">
        <Image src={congratsImage} height="100%" maxH="48vh" />
        <Text
          mt={{base: '0', md: '-lg'}}
          maxWidth="450px"
          mx="auto"
          textStyle="headline2"
          textAlign="center"
        >
          {t('onboarding:AcquisitionDecisionSupported.heading')}
        </Text>

        <Text
          maxWidth="450px"
          mx="auto"
          textStyle="body-intro"
          my="md"
          textAlign="center"
          color="mld.neutral.700"
        >
          {t('onboarding:AcquisitionDecisionSupported.body')}
        </Text>
        <Flex justifyContent="center">
          <Button
            variant="primary"
            onClick={() => transitionTo('complete')}
            colorScheme="primary"
            type="submit"
            data-testid="continue-button"
            size="lg"
            mt="sm"
          >
            {t('onboarding:AcquisitionDecisionSupported.submitButton')}
            <ArrowRightIcon width="24px" height="24px" ml="xs" />
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default Supported
